import { TcRpmPowerResponse } from '@navstation-portal/reporting/data-model/vessel-report';
import { DropboxItem } from '@navstation-portal/shared/data-model/common';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../create-form-store-events';
import { EdnFileType } from '../report-dependencies';

export const powerEvents = createFormStoreEvents('powerStore');

export const powerFlowMeterEvents = eventGroup({
  source: 'powerStore',
  events: {
    initialiseFlowMeterInstallation: type<{ paths: string[] }>(),
  },
});

export const shorePowerDocumentEvents = eventGroup({
  source: 'powerStore',
  events: {
    queueEdnFile: type<{ ednType: EdnFileType; file: File }>(),
    dequeueEdnFile: type<{ ednType: EdnFileType }>(),
    uploadEdnFile: type<{ vesselId: string; reportId: string; ednType: EdnFileType; file: File }>(),
    uploadEdnFileSuccess: type<{ ednType: EdnFileType; files: DropboxItem[] }>(),
    uploadEdnFileFailed: type<{ ednType: EdnFileType; error: string }>(),
    deleteEdnFile: type<{ vesselId: string; reportId: string; ednType: EdnFileType; dropboxUrl: string }>(),
    deleteEdnFileSuccess: type<{ ednType: EdnFileType; files: DropboxItem[] }>(),
    deleteEdnFileFailed: type<{ ednType: EdnFileType; error: string }>(),
  },
});

export const powerCalculationEvents = eventGroup({
  source: 'powerStore',
  events: {
    // combines ReportService.getTcRpmPower with getMeRpmPower (for non-legacy reports)
    // into the single tcRpmPower field, see calculateTcRpmPower in with-power-effects.ts
    getTcRpmPower: type<{ tcrpm1: number | undefined; tcrpm2: number | undefined; rpm: number | undefined }>(),
    getTcRpmPowerSuccess: type<TcRpmPowerResponse>(),
    getTcRpmPowerFailed: type<Error>(),
    // The report holds no input for the Average TC RPM Power.
    clearTcRpmPower: type<void>(),
  },
});
